import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type DreamSearchItemFragmentFragment = { __typename?: 'DreamSearchItem', id: string, score: number, distance: number, favorited: boolean, label: Types.ProgramTag | null, provider: { __typename?: 'Provider', id: string, fullName: string, isPartnered: boolean, slug: string, complianceExclusionTags: Array<string>, logoImageFile: { __typename?: 'ImageFile', id: string, url: string | null } | null, publicDisplayFields: { __typename?: 'ProviderPublicDisplayFields', id: string, aboutSchool: string | null } | null, geocode: { __typename?: 'Geocode', id: string, point: {
        lat: number;
        long: number;
      } }, detailsMap: { __typename?: 'ProviderDetailMap', id: string, logoPalette: { __typename?: 'LogoPalette', muted: string | null } | null } }, program: { __typename?: 'Program', id: string, environment: Types.ProgramEnvironment, environmentCompliance: boolean, name: string, slug: string, customCtaCopy: string | null, preLeadRedirect: string | null, preLeadRedirectParams: {
      [key: string]: any;
    } | null, preLeadRedirectCompositeParams: {
      [key: string]: any;
    } | null, preLeadRedirectSuppressDefaultParams: boolean | null, preLeadRedirectInIframe: boolean | null, allowHybridSignup: boolean, programHighlights: Array<string>, tags: Array<Types.ProgramTag>, programLevel: Types.ProgramLevel, publicDisplayFields: { __typename?: 'ProgramPublicDisplayFields', id: string, aboutProgramPlainText: string | null } | null, vocation: { __typename?: 'Vocation', id: string, abbreviation: string | null, adjective: string }, costs: Array<{ __typename?: 'ProgramCost', id: string, cost: number }>, eligiblePaymentOptions: Array<{ __typename?: 'PaymentOption', id: string, type: Types.PaymentOptionType, estimatedFirstPayment: number | null, isVisible: boolean, config: { __typename?: 'PaymentOptionConfig', id: string, description: string | null } }> } };

export type DreamSearchForDreamSearchQueryVariables = Types.Exact<{
  dreamSearchFilters: Types.DreamSearchFilters;
  geo: Types.DreamSearchGeo;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  complianceExclusionTags: Array<Types.Scalars['String']['input']>;
  pinnedProgramId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DreamSearchForDreamSearchQuery = { __typename?: 'Query', dreamSearchItemsConnection: { __typename?: 'QueryDreamSearchItemsConnection_Connection', city: string, state: string, zip: string, totalCount: number, edges: Array<{ __typename?: 'DreamSearchItemEdge', cursor: number, node: { __typename?: 'DreamSearchItem', id: string, score: number, distance: number, favorited: boolean, label: Types.ProgramTag | null, provider: { __typename?: 'Provider', id: string, fullName: string, isPartnered: boolean, slug: string, complianceExclusionTags: Array<string>, logoImageFile: { __typename?: 'ImageFile', id: string, url: string | null } | null, publicDisplayFields: { __typename?: 'ProviderPublicDisplayFields', id: string, aboutSchool: string | null } | null, geocode: { __typename?: 'Geocode', id: string, point: {
              lat: number;
              long: number;
            } }, detailsMap: { __typename?: 'ProviderDetailMap', id: string, logoPalette: { __typename?: 'LogoPalette', muted: string | null } | null } }, program: { __typename?: 'Program', id: string, environment: Types.ProgramEnvironment, environmentCompliance: boolean, name: string, slug: string, customCtaCopy: string | null, preLeadRedirect: string | null, preLeadRedirectParams: {
            [key: string]: any;
          } | null, preLeadRedirectCompositeParams: {
            [key: string]: any;
          } | null, preLeadRedirectSuppressDefaultParams: boolean | null, preLeadRedirectInIframe: boolean | null, allowHybridSignup: boolean, programHighlights: Array<string>, tags: Array<Types.ProgramTag>, programLevel: Types.ProgramLevel, publicDisplayFields: { __typename?: 'ProgramPublicDisplayFields', id: string, aboutProgramPlainText: string | null } | null, vocation: { __typename?: 'Vocation', id: string, abbreviation: string | null, adjective: string }, costs: Array<{ __typename?: 'ProgramCost', id: string, cost: number }>, eligiblePaymentOptions: Array<{ __typename?: 'PaymentOption', id: string, type: Types.PaymentOptionType, estimatedFirstPayment: number | null, isVisible: boolean, config: { __typename?: 'PaymentOptionConfig', id: string, description: string | null } }> } } }>, filterSettings: { __typename?: 'DreamSearchFilterSettings', environment: Array<Types.ProgramEnvironment>, paymentOptionType: Array<Types.PaymentOptionType>, programDuration: Array<"90" | "180" | "365" | "730">, programLevel: Array<Types.ProgramLevel>, programTag: Array<Types.ProgramTag>, subindustries: Array<Types.VocationSubindustry>, industries: Array<Types.VocationIndustry>, vocation: Array<{ __typename?: 'Vocation', id: string, abbreviation: string | null, adjective: string }> }, otherRecommendedItems: Array<{ __typename?: 'DreamSearchItem', id: string, score: number, distance: number, favorited: boolean, label: Types.ProgramTag | null, provider: { __typename?: 'Provider', id: string, fullName: string, isPartnered: boolean, slug: string, complianceExclusionTags: Array<string>, logoImageFile: { __typename?: 'ImageFile', id: string, url: string | null } | null, publicDisplayFields: { __typename?: 'ProviderPublicDisplayFields', id: string, aboutSchool: string | null } | null, geocode: { __typename?: 'Geocode', id: string, point: {
            lat: number;
            long: number;
          } }, detailsMap: { __typename?: 'ProviderDetailMap', id: string, logoPalette: { __typename?: 'LogoPalette', muted: string | null } | null } }, program: { __typename?: 'Program', id: string, environment: Types.ProgramEnvironment, environmentCompliance: boolean, name: string, slug: string, customCtaCopy: string | null, preLeadRedirect: string | null, preLeadRedirectParams: {
          [key: string]: any;
        } | null, preLeadRedirectCompositeParams: {
          [key: string]: any;
        } | null, preLeadRedirectSuppressDefaultParams: boolean | null, preLeadRedirectInIframe: boolean | null, allowHybridSignup: boolean, programHighlights: Array<string>, tags: Array<Types.ProgramTag>, programLevel: Types.ProgramLevel, publicDisplayFields: { __typename?: 'ProgramPublicDisplayFields', id: string, aboutProgramPlainText: string | null } | null, vocation: { __typename?: 'Vocation', id: string, abbreviation: string | null, adjective: string }, costs: Array<{ __typename?: 'ProgramCost', id: string, cost: number }>, eligiblePaymentOptions: Array<{ __typename?: 'PaymentOption', id: string, type: Types.PaymentOptionType, estimatedFirstPayment: number | null, isVisible: boolean, config: { __typename?: 'PaymentOptionConfig', id: string, description: string | null } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export const DreamSearchItemFragmentFragmentDoc = gql`
    fragment DreamSearchItemFragment on DreamSearchItem {
  id
  score
  distance
  favorited
  label
  provider {
    id
    fullName
    logoImageFile {
      id
      url
    }
    isPartnered
    slug
    publicDisplayFields {
      id
      aboutSchool
    }
    geocode {
      id
      point
    }
    detailsMap {
      id
      logoPalette {
        muted
      }
    }
    complianceExclusionTags
  }
  program {
    id
    environment
    environmentCompliance
    name
    slug
    customCtaCopy
    preLeadRedirect
    preLeadRedirectParams
    preLeadRedirectCompositeParams
    preLeadRedirectSuppressDefaultParams
    preLeadRedirectInIframe
    allowHybridSignup
    publicDisplayFields {
      id
      aboutProgramPlainText
    }
    programHighlights
    vocation {
      id
      abbreviation
      adjective
    }
    costs {
      id
      cost
    }
    eligiblePaymentOptions: loaderEligiblePaymentOptions {
      id
      type
      estimatedFirstPayment
      config {
        id
        description
      }
      isVisible
    }
    tags
    programLevel
  }
}
    ` as unknown as DocumentNode<DreamSearchItemFragmentFragment, unknown>;
export const DreamSearchForDreamSearchDocument = gql`
    query dreamSearchForDreamSearch($dreamSearchFilters: DreamSearchFilters!, $geo: DreamSearchGeo!, $first: Int!, $after: Int, $complianceExclusionTags: [String!]!, $pinnedProgramId: ID) {
  dreamSearchItemsConnection(
    filter: $dreamSearchFilters
    geo: $geo
    first: $first
    after: $after
    complianceExclusionTags: $complianceExclusionTags
    pinnedProgramId: $pinnedProgramId
    includeFilterSettings: true
    includeOtherRecommendedItems: true
  ) {
    edges {
      cursor
      node {
        ...DreamSearchItemFragment
      }
    }
    city
    state
    zip
    filterSettings {
      vocation {
        id
        abbreviation
        adjective
      }
      environment
      paymentOptionType
      programDuration
      programLevel
      programTag
      subindustries
      industries
    }
    otherRecommendedItems {
      ...DreamSearchItemFragment
    }
    totalCount
    pageInfo {
      hasNextPage
    }
  }
}
    ${DreamSearchItemFragmentFragmentDoc}` as unknown as DocumentNode<DreamSearchForDreamSearchQuery, DreamSearchForDreamSearchQueryVariables>;